import { ReactElement } from 'react';
import Modal from 'sling-sdk/src/components/ui/modal/Modal';
import ModalBodyWithHeader from '@sdk/components/ui/modal/ModalBodyWithHeader';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { User } from '@sdk/users/types/User';
import Spinner from '@sdk/components/ui/Spinner';
import Button from 'sling-sdk/src/components/ui/buttons/Button';
import gettext from 'sling-sdk/src/lang/gettext';

import { UserPreviewListItem } from '@web/newsfeed/components/UserPreviewListItem/UserPreviewListItem';
import BodyPortal from '@web/components/BodyPortal';

import {
  Container,
  ItemsContainer,
  FooterContainer,
  ButtonContainer,
} from './userPreviewListModal.styles';

type Props = {
  isVisible: boolean;
  onClose: () => void;
  isLoading: boolean;
  users: User[];
  title: string;
  icon?: ReactElement;
};

export const UserPreviewListModal = ({
  isVisible,
  onClose,
  isLoading,
  users,
  title,
  icon,
}: Props) => (
  <BodyPortal>
    <Modal isVisible={isVisible} onDismiss={onClose} fixed>
      <ModalBodyWithHeader
        width={620}
        titleThemeColor={ThemeColorType.primary}
        titleText={title}
        titleIcon={icon}
        close={onClose}>
        <Container>
          {isLoading ? (
            <Spinner />
          ) : (
            <ItemsContainer>
              {users.map((u) => (
                <UserPreviewListItem key={u.id} user={u} />
              ))}
            </ItemsContainer>
          )}
        </Container>
        <FooterContainer>
          <ButtonContainer>
            <Button onClick={onClose}>{gettext('Close')}</Button>
          </ButtonContainer>
        </FooterContainer>
      </ModalBodyWithHeader>
    </Modal>
  </BodyPortal>
);
